export const ChevronCalendarRightIcon = () => (
  <svg
    width="9"
    height="10"
    viewBox="-2 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.750037 0.5L5.25 5L0.75 9.5"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeMiterlimit="16"
    />
  </svg>
);
